import { useFirestore, useFirestoreDocData, useUser } from "reactfire";
import { doc, getDoc } from "firebase/firestore";
import { useEffect, useState } from "react";
import { FIRESTORE_USERS_TABLE } from "../../../constants/FirebaseConstants";

export function useUserProfile() {
  const firestore = useFirestore();
  const { data: user } = useUser();
  const docRef = doc(firestore, FIRESTORE_USERS_TABLE, user?.uid || "default");
  const { data, status } = useFirestoreDocData(docRef, { idField: "uid" });

  // Salesperson fetch via Firestore SDK (no Reactfire hook)
  const salesPersonId = data?.salesPerson || null;
  const [salesPerson, setSalesPerson] = useState(null);
  const [salesPersonLoading, setSalesPersonLoading] = useState(false);
  const [salesPersonError, setSalesPersonError] = useState(null);

  useEffect(() => {
    let cancelled = false;
    async function run() {
      if (!salesPersonId) {
        if (!cancelled) {
          setSalesPerson(null);
          setSalesPersonLoading(false);
          setSalesPersonError(null);
        }
        return;
      }
      try {
        if (!cancelled) {
          setSalesPersonLoading(true);
          setSalesPersonError(null);
        }
        const ref = doc(firestore, FIRESTORE_USERS_TABLE, salesPersonId);
        const snap = await getDoc(ref);
        if (!cancelled) {
          setSalesPerson(
            snap.exists() ? { uid: snap.id, ...snap.data() } : null,
          );
        }
      } catch (e) {
        if (!cancelled) {
          setSalesPersonError(e);
          setSalesPerson(null);
        }
      } finally {
        if (!cancelled) setSalesPersonLoading(false);
      }
    }
    run();
    return () => {
      cancelled = true;
    };
  }, [firestore, salesPersonId]);

  const isLoading =
    status === "loading" ||
    !user ||
    (salesPersonId ? salesPersonLoading === true : false);

  return {
    data,
    salesPerson,
    isLoading,
  };
}
